

// Componente de overlay de carregamento
export function ImageLoadingOverlay({ isLoading }: { isLoading: boolean }) {
    if (!isLoading) return null
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                zIndex: 100,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '8px',
                }}
            >
                <div
                    style={{
                        width: '30px',
                        height: '30px',
                        border: '3px solid #f3f3f3',
                        borderTop: '3px solid #6993ff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                    }}
                />
                <small style={{ color: '#677484', fontSize: '12px' }}>Carregando...</small>
            </div>
            <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
        </div>
    )
}